import '@/registerServiceWorker';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueMeta from 'vue-meta';
import VueMask from 'v-mask';
import InputFacade from 'vue-input-facade';
import VueRouter from 'vue-router';
import letterCapitalDirective from '@/directives/letterCapitalDirective';
import Updater from '@/plugins/updater';
import VueMetric from '@/plugins/metric';
import App from '@/App.vue';
import store from '@/store';
import SentryPlugin from '@/plugins/sentry';
import Router from '@/router';
import vuetify from '@/plugins/vuetify';
import { AUTH_LOGOUT, AUTH_REFRESH } from '@/store/actions/auth';
import { VUE_APP_ROOT_API } from '@/transformEnv';
import { VueStoragePlugin } from '@/storage';
import { createAxios, createAxiosWithErrorHandlers } from '@/plugins/axios';
import { createErrorHandler } from '@/plugins/logger';
import Logger, { AxiosTransport } from '@/loggers';

const updater = new Updater();
const router = new Router(() => { updater.tryToNextVersion(); });
const resolveToken = () => store.getters.token;
const storageAxios = createAxiosWithErrorHandlers(
  VUE_APP_ROOT_API,
  () => store.dispatch(AUTH_REFRESH),
  () => { store.dispatch(AUTH_LOGOUT).then(() => { router.push({ name: 'Auth' }); }); },
  resolveToken,
);

Vue.config.productionTip = false;
Vue.config.errorHandler = createErrorHandler(
  new Logger(new AxiosTransport(
    createAxios(VUE_APP_ROOT_API, resolveToken),
    'api/web-app-logs',
  )),
);

Vue.directive('letter-capital', letterCapitalDirective);

Vue.use(new SentryPlugin(router));
Vue.use(VueAxios, storageAxios);
Vue.use(new VueStoragePlugin(storageAxios));
Vue.use(VueMeta);
Vue.use(VueMask, {
  placeholders: {
    D: /\d/,
    Я: /[\wа-яА-Я]/,
  },
});
Vue.use(InputFacade);
Vue.use(VueRouter);
Vue.use(new VueMetric());
Vue.use(updater);

new Vue({
  render: (createElement) => createElement(App),
  router,
  store,
  vuetify,
}).$mount('#app');
